import React from 'react'
import { Link } from 'react-router-dom';

export default function ByNumberForm(props) {
    return (
        <div>
            <div className='access__to__data'>
                <p>
                    Ограниченный доступ до утверждения клиентским менеджером:
                </p>
            </div>

            <Link to="/registration">
                <button className='by_phone'>{props.translate("По номеру телефона")}</button>
            </Link>
        </div>
    );
}